import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioAdminComponent } from './inicio-admin/inicio-admin.component';
import { SolicitudesCitasComponent } from './solicitudes-citas/solicitudes-citas.component';
import { CitasProgramadasComponent } from './citas-programadas/citas-programadas.component';
import { HistorialCitasComponent } from './historial-citas/historial-citas.component';
import { DetalleCitaAsignadaComponent } from './detalle-cita-asignada/detalle-cita-asignada.component';

const routes: Routes = [
  { 
    path: '', 
    redirectTo: 'home', 
    pathMatch: 'full' 
  },
  {
    path: 'home',
    component: InicioAdminComponent
  },
  {
    path: 'appointment-request',
    component: SolicitudesCitasComponent
  },
  {
    path: 'scheduled-appointments',
    component: CitasProgramadasComponent
  },
  {
    path: 'appointment-history',
    component: HistorialCitasComponent
  },
  {
    path: 'appointment-detail',
    component: DetalleCitaAsignadaComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagesAdminRoutingModule { }
